<template>
  <div class="viewer-layout-root" :class="{ 'viewer-layout-root--desktop-title-sidebar-aligned': shouldAlignDesktopTitleWithSidebarLogo }">
    <slot />
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useBranding } from '@/composables/useBranding';

const { orgCustomLogoUrl } = useBranding();
const shouldAlignDesktopTitleWithSidebarLogo = computed(() => !orgCustomLogoUrl.value);
</script>

<style scoped>
.viewer-layout-root {
  @apply relative flex flex-col w-full pt-12 sm:pt-6;
}

@media (min-width: 640px) {
  .viewer-layout-root--desktop-title-sidebar-aligned {
    padding-top: 0.5rem;
  }
}
</style>
